export const hhMmToHours = timeString => {
  const arr = timeString.split(":");
  return arr[0] * 1;
};
